/**
 * Utilities for filtering Storyblok content by store
 */

export type StoreItem = {
	stores?: readonly (string | null)[] | null;
	_uid?: string | null;
	component?: string | null;
};

/**
 * Filters a storyblok item by store
 * @param item The storyblok item to filter
 * @param store The current store code
 * @returns True if the item should be included for the current store
 */
export const filterByStore = (
	item: StoreItem | null | undefined,
	store: string,
): boolean => {
	if (
		!item ||
		(item.stores &&
			Array.isArray(item.stores) &&
			item.stores.length > 0 &&
			!item.stores.includes(store))
	)
		return false;
	return true;
};
